import queryString from 'query-string';
import { orderBy } from 'lodash';

import i18n from 'i18n/index';
import { User, Role } from 'common/types/user.type';
import { Row, Response, TableData, Repo, RequiredField } from 'common/types/admin-page.type';

export function toTableData<T>(response: Response<T>): TableData<T> {
  const { data, ...rest } = response;
  return { ...rest, rows: data.map(toRow) };
}

export function toRow<T>(user: T): Row<T> {
  return { ...user, isSelected: false, isDeleted: false };
}

export function queryStringify(object: Record<string, any>): string {
  return queryString.stringify(object, { skipEmptyString: true, skipNull: true });
}

export function deleteRows<T extends RequiredField>(removeCallback: Repo<T>['remove']) {
  return async (rows: T[]) => {
    await Promise.all(rows.map((row) => removeCallback(row.id)));
  };
}

export function getFilterPlaceholder(name: string) {
  return i18n.t('view.admin.filterBy', { field: name.toLowerCase() });
}

export function getFormTitle(name: string, mode: 'create' | 'edit' = 'create') {
  return `${capitalizeFirstLetter(name)} ${i18n.t(`view.admin.${mode}`)} `;
}

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function sortUsers(users: User[]): User[] {
  return orderBy(
    [...users],
    [
      (user) => user.company?.name.toLocaleLowerCase(),
      (user) => Role[user.role as keyof typeof Role],
      (user) => user.enabled,
      (user) => user.firstName.toLocaleLowerCase(),
    ],
    ['asc', 'desc', 'desc', 'asc']
  );
}

export function getSvgSrcUrl(svg: string) {
  return URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
}
